import {ReactNode} from 'react';

const TestPage = ({children}: {children: ReactNode}) => {
  return <h1>{children}</h1>;
};

export default TestPage;
